/* eslint-disable @typescript-eslint/no-unused-expressions */
import { Flex, Grid, Text } from '@chakra-ui/react'
import { iTop10 } from '../..'

interface IProps{
  quantidade?: number | string
  titulo: string
  icon?: any
  color?: string
  tabela?: iTop10[]
  small?: boolean
  onClick?: (tabelaLinha?: string) => void
}

export const BoxQtd: React.FC<IProps> = ({ quantidade, titulo, icon, tabela, color, small, onClick }) => {
  return (
    <Flex border={'1px solid var(--c6)'} alignItems={'center'} justifyContent={'center'} h={tabela ? '25.75rem' : small ? '4.75rem' : '9rem'} width={'100%'} boxShadow={'var(--SombraBackground)'} bg={'var(--c1)'} px={'1rem'} borderRadius={'.325rem'} flexDir='column' gap={'.5rem'} py={small ? '1rem' : undefined} _hover={onClick ? { boxShadow: 'var(--SombraBtns)', filter: 'brightness(1.02)', border: `1px solid ${color}`, cursor: 'pointer' } : undefined} onClick={() => { (!tabela && onClick) ? onClick() : undefined }}>
      <Text fontSize={small ? '14px' : '18px'} fontWeight={'400'} lineHeight={small ? '14px' : '18px'} textAlign='center'>{titulo}</Text>
      {quantidade !== undefined && quantidade !== null && <Flex fontSize={small ? '16px' : '24px'} fontWeight={'700'} color={color ?? 'var(--Azul)'} alignItems='center' gap={'.75rem'}>
        {icon}
        {quantidade}
      </Flex>}
      {tabela && <Flex flexDir={'column'} width={'100%'} mt={'1rem'} maxHeight={'20rem'} overflowY={'auto'}>
          <Grid bg={'var(--Azul)'} color={'var(--c1)'} border={'1px solid var(--c4)'} borderBottom={'none'} p={'.25rem .75rem'} gridTemplateColumns={'1fr 3rem'} width={'100%'}>
            <Flex fontSize={'12px'} fontWeight={700}>Nome</Flex>
            <Flex fontSize={'12px'} fontWeight={700} justifyContent={'end'} pr={'1rem'}>Vagas</Flex>
          </Grid>
          {tabela.length > 0
            ? tabela.map(e => {
              return (
              <Grid bg={'var(--AzulOpacoBg)'} border={'1px solid var(--c4)'} p={'.25rem .75rem'} gridTemplateColumns={'1fr 3rem'} width={'100%'} _hover={onClick ? { bg: 'var(--Azul)', color: '#fff', fontWeight: 700, cursor: 'pointer' } : undefined} onClick={() => { if (onClick) { onClick(e.nomeBp) } }}>
                <Flex fontSize={'12px'}>{e.nomeBp}</Flex>
                <Flex fontSize={'12px'} fontWeight={'600'} justifyContent={'end'} pr={'1rem'}>{e.quantidade}</Flex>
              </Grid>
              )
            })
            : <Flex fontWeight={'600'} textAlign={'center'} justifyContent={'center'} py={'.75rem'}>Ainda não houveram resgistros de nenhum business partner</Flex>}
          {}
        </Flex>}
    </Flex>
  )
}
